<script lang="ts">
    import data from "../../../Data/SearchResult/SearchResult.json"
    import { href } from "../../../utils/Constant/Constant";
    import {searchResults} from "../../../store"
    import { Nav, NavItem, NavLink } from "sveltestrap";
    const handleTab =(getId:string) =>{
        if(getId !== undefined){
            searchResults.update(value => value = getId)
        }
    }
    let setSearchResult:string
    searchResults.subscribe((value)=>{
        setSearchResult = value
    })
</script>
<Nav class="nav-tabs search-list" id="top-tab" role="tablist">
    {#each data.searchnavdata as searchItem}
        <NavItem>
            <NavLink class={`${setSearchResult == searchItem.id ? "active" : ""}`} id={searchItem.id} href={href}  on:click={()=>handleTab(searchItem.id)}>
                {#if searchItem.icon}
                    <i class={searchItem.icon}></i>
                {/if}
                {searchItem.name}
            </NavLink>
            <div class="material-border"></div>
        </NavItem>
    {/each}
</Nav>
